'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const fastdom=require('fastdom');

const DefaultServiceParams={
_axisDirective:null,
scheduleRowDirectives:new Set,
_scheduleScrollClasses:{"right-scrollable":!1,"left-scrollable":!1}};


const DayInMs=8.64e7;
const DefaultWindowSizeInDays=20/24;
const MaxWindowSizeInDays=20/24;
const MinWindowSizeInDays=20/24;let

ScheduleRowScrollingService=class ScheduleRowScrollingService extends BaseService{
constructor($rootScope){
super();

this._$rootScope=$rootScope;

_.defaults(this,DefaultServiceParams);
}

_updateScheduleScrollClasses(){
this._scheduleScrollClasses['right-scrollable']=this._axisDirective.axisBounds.end.getTime()>this._axisDirective.currentBounds.end.getTime();
this._scheduleScrollClasses['left-scrollable']=this._axisDirective.axisBounds.start.getTime()<this._axisDirective.currentBounds.start.getTime();
}

get scheduleScrollClasses(){
return this._scheduleScrollClasses;
}

setAxis(scheduleRowAxisDirective){
this._axisDirective=scheduleRowAxisDirective;
}

registerScheduleRowDirective(directive){
this.scheduleRowDirectives.add(directive);
}

unregisterScheduleRowDirective(directive){
this.scheduleRowDirectives.delete(directive);
}

async updateScheduleWindows(throttledUpdateTimeInMs=0){
const windowUpdateOptions=throttledUpdateTimeInMs!==0?
{animation:{duration:throttledUpdateTimeInMs,easingFunction:'linear'}}:
{animation:!1};

for(const scheduleRow of this.scheduleRowDirectives){
scheduleRow._updateWindow(this.axisBounds,windowUpdateOptions);
}

await new Promise(resolve=>{
this._$rootScope.$evalAsync(()=>{
this._updateScheduleScrollClasses();
resolve();
});
});
}

updateScheduleRowOptions(newOptions){
for(const scheduleRow of this.scheduleRowDirectives){
scheduleRow._updateOptions(newOptions);
}
}

get axisBounds(){
if(!_.exists(this._axisDirective)){
throw new Error('No axis registered!');
}

return this._axisDirective.currentBounds;
}

get defaultWindowSizeInMilliseconds(){
return DefaultWindowSizeInDays*DayInMs;
}

get maxWindowSizeInMilliseconds(){
return MaxWindowSizeInDays*DayInMs;
}

get minWindowSizeInMilliseconds(){
return MinWindowSizeInDays*DayInMs;
}};


module.exports=ScheduleRowScrollingService;
//# sourceMappingURL=scheduleRowScrollingService.js.map
